<template>
    <v-layout
            v-if="locked"
            row
            wrap
            align-center
            justify-center
            class="locked transition-fast-in-fast-out"
            :class="getSize"
    >
        <v-flex xs12>
            <v-flex xs12>
                <!--  <p class="display-3 white--text">Coming soon</p> -->
            </v-flex>
            <v-flex xs12>
                <v-icon
                        color="white"
                        size="96px"
                >
                    lock
                </v-icon>
            </v-flex>
        </v-flex>
    </v-layout>
</template>


<script>
    export default {
        name: "LockedContent",
        props: ["locked", "fullScreen"],
        data() {
            return {};
        },
        computed: {
            getSize() {
                if (this.fullScreen === true) {
                    return "locked-fullscreen";
                }
                return "locked-locally";
            },
        },
    };
</script>

<style scoped lang="scss">

</style>
